import type { SxStyle } from '@aibees/shared/theme';

export const root: SxStyle = {
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center',
};

export const header: SxStyle = {
  background: (p) => `${p.palette.common.white} !important`,
  borderBottom: (p) => `1px solid  ${p.palette.grey[300]} !important`,
};
